// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img[data-v-5ab24d1b] {\n  max-height: 40px;\n}\n.logo-link[data-v-5ab24d1b] {\n  color: white !important;\n}\n.school-link[data-v-5ab24d1b] {\n  text-decoration: none;\n  display: block;\n  margin-top: 0;\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--theme-navbar-link, #ffffff);\n}\n.school-link[data-v-5ab24d1b]:hover {\n  color: var(--theme-navbar-link, #ffffff);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
